module.exports = __webpack_public_path__ + "static/media/104.36ce5695.webp";